import styled from 'styled-components'
import { PageTitle } from 'components/PageTitle'

type TProps = {
  textColor: string
}

export const StyledThanksForSharing = {
  Title: styled(PageTitle)`
    text-align: left;
    margin-top: 40px;
  `,
  Text: styled.div<TProps>`
    font-weight: 500;
    font-size: 17px;
    line-height: 24px;

    p {
      margin-bottom: 24px;
    }

    strong {
      text-transform: lowercase;
      color: ${({ textColor }) => textColor};
      font-size: 24px;
    }
  `,
}
